var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { Link } from "react-router-dom";
import { Dimmer, Header, Loader, Message, Table } from "semantic-ui-react";
import { displayLocalTimestamp } from "./admin/AllOrdersPage";
import { AppPaths } from "./AppConfig";
import { ORIGIN } from "./Config";
import { getWithAuthn } from "./RequestHelpers";
var UserOrderListPage = /** @class */ (function (_super) {
    __extends(UserOrderListPage, _super);
    function UserOrderListPage(props) {
        var _this = _super.call(this, props) || this;
        _this.loadOrders = function () {
            _this.setState({ loading: true }, function () {
                getWithAuthn('/user/orders/all')
                    .then(function (resp) {
                    if (resp.status === 200) {
                        return resp.json();
                    }
                    else if (resp.status === 401) {
                        _this.props.history.push(AppPaths.LOG_IN, {
                            referrerLocation: _this.props.location
                        });
                        return false;
                    }
                    else {
                        return undefined;
                    }
                })
                    .then(function (resp) {
                    if (resp === undefined) {
                        _this.setState({
                            loading: false,
                            error: true
                        });
                    }
                    else if (resp === false) {
                        // 401, do nothing
                    }
                    else {
                        _this.setState({
                            loading: false,
                            orders: resp.orders
                        });
                    }
                })
                    .catch(function (rej) {
                    console.error("Couldn't load orders: " + rej);
                });
            });
        };
        _this.state = {
            loading: false,
            error: false,
            orders: []
        };
        return _this;
    }
    UserOrderListPage.prototype.render = function () {
        return React.createElement(React.Fragment, null,
            React.createElement(Dimmer.Dimmable, { id: "non-header-portion" },
                React.createElement(Dimmer, { active: this.state.loading, inverted: true },
                    React.createElement(Loader, null)),
                React.createElement(Header, null, "Orders"),
                this.state.error &&
                    React.createElement(Message, { negative: true }, "Orders could not be loaded."),
                React.createElement(Table, { striped: true, celled: true },
                    React.createElement(Table.Header, null,
                        React.createElement(Table.Row, null,
                            React.createElement(Table.HeaderCell, null, "Order"),
                            React.createElement(Table.HeaderCell, null, "Nickname"),
                            React.createElement(Table.HeaderCell, null, "Status"),
                            React.createElement(Table.HeaderCell, null, "Created"))),
                    React.createElement(Table.Body, null, this.state.orders.filter(function (o) { return ORIGIN === o.uiOrigin; })
                        .map(function (o, index) {
                        return React.createElement(Table.Row, { key: index },
                            React.createElement(Table.Cell, null,
                                React.createElement(Link, { to: AppPaths.ORDER_BASE + "/" + o.id }, o.id)),
                            React.createElement(Table.Cell, null, truncateAndEllipsize(o.nickname, 30)),
                            React.createElement(Table.Cell, null, o.status),
                            React.createElement(Table.Cell, null, displayLocalTimestamp(o.createdAt)));
                    })))));
    };
    UserOrderListPage.prototype.componentDidMount = function () {
        this.loadOrders();
    };
    return UserOrderListPage;
}(React.PureComponent));
export default UserOrderListPage;
/**
 * Chop a string down to its first line and limit.
 *
 * If the string is truncated, an ellipsis will be added.
 *
 * @param s string to truncate
 * @param lengthLimit the max length of the returned string (not counting the ellipsis).
 */
export var truncateAndEllipsize = function (s, lengthLimit) {
    var lines = s.split(/\r\n|\r|\n/);
    var ellipsize = false;
    if (lines.length > 1) {
        ellipsize = true;
    }
    var firstLine = lines[0];
    if (firstLine.length > lengthLimit) {
        ellipsize = true;
    }
    return firstLine.substr(0, lengthLimit) + (ellipsize ? '…' : '');
};
//# sourceMappingURL=UserOrderListPage.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/UserOrderListPage.js
// module id = 1309
// module chunks = 0